import React from "react";
import "../../styles/LearningStreams.css";

const LearningStreams = () => {
  const programsData = [
    {
      id: 1,
      theme: "blue", 
      title: "CA Foundation, Intermediate, and Final",
      desc: "Concept-based learning with ICAI updated syllabus coverage.",
      img: "https://i.pinimg.com/736x/c7/4d/8d/c74d8db953a1c199c5b513fdae843aab.jpg"
    },
    {
      id: 2,
      theme: "purple", 
      title: "CMA Foundation, Intermediate, and Final",
      desc: "Exam-oriented approach with real-life case study applications.",
      img: "https://i.pinimg.com/736x/66/e3/41/66e3418ee7a9acd64bcf68283aaa7bc9.jpg"
    },
    {
      id: 3,
      theme: "green", 
      title: "CS Executive & Professional",
      desc: "Corporate governance, compliance, and law training with practical exposure.",
      img: "https://i.pinimg.com/1200x/64/db/50/64db5044e7557a81da11031e12548f70.jpg"
    }
  ];

  return (
    <section className="programs-section container">
      <h2 className="section-main-title">Our Programs</h2>
      
      <div className="programs-grid">
        
        {/* Top Row: 2 Cards */}
        <div className="row g-4 justify-content-center mb-4">
          {programsData.slice(0, 2).map((program) => (
            <div key={program.id} className="col-lg-6 col-md-12">
              {/* Added inline style for background image */}
              <div 
                className={`program-card card-${program.theme}`}
                style={{ backgroundImage: `url(${program.img})` }}
              >
                <div className="card-content">
                  <h3 className="program-title">
                    <span>
                      {program.title.split(",")[0]}
                      {program.title.includes(",") && "," + program.title.split(",").slice(1).join(",")}
                    </span>
                  </h3>
                  <p className="program-desc">{program.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Row: 1 Card (Centered) */}
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
             <div 
                className={`program-card card-${programsData[2].theme}`}
                style={{ backgroundImage: `url(${programsData[2].img})` }}
             >
                <div className="card-content">
                  <h3 className="program-title">
                    <span >{programsData[2].title}</span>
                  </h3>
                  <p className="program-desc">{programsData[2].desc}</p>
                </div>
              </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LearningStreams;